// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.
import React, { ImgHTMLAttributes, ReactElement } from "react";

import { EditableProps } from "components/Editor/EditablePropsType";
import ServerAsset from "./ServerAsset";
import { getDefaultQuestionDefinition } from "./Questionnaire/QuestionnaireUtils";
import { onlyNumberFormatter } from "./Questionnaire/QuestionnaireFormatters";

export interface AssetsImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  alt: string; // make it mandatory.
  // Width and height are mandatory so that the image space in the UI is reserved.
  // Without this, the UI would jump while the image is being loaded.
  width: number;
  height: number;
  type?: "server" | "local";
}

export const AssetEditableProps: EditableProps = {
  alt: {
    ...getDefaultQuestionDefinition(),
    label: "alt",
    mandatory: true,
    name: "alt",
    valueType: "string",
  },
  width: {
    ...getDefaultQuestionDefinition(),
    formatter: onlyNumberFormatter,
    label: "width",
    mandatory: true,
    name: "width",
    validators: [],
    valueType: "number",
  },
  height: {
    ...getDefaultQuestionDefinition(),
    formatter: onlyNumberFormatter,
    label: "height",
    mandatory: true,
    name: "height",
    valueType: "number",
  },
  type: {
    ...getDefaultQuestionDefinition(),
    label: "type",
    mandatory: true,
    name: "type",
    type: "select",
    valueType: "string",
    selectOptions: [
      { name: "server", value: "server" },
      { name: "local", value: "local" },
    ],
  },
  src: {
    ...getDefaultQuestionDefinition(),
    label: "src",
    mandatory: true,
    name: "src",
    valueType: "string",
  },
};

export type AssetComponent = (props: AssetsImageProps) => ReactElement;

const Asset: AssetComponent = (props: AssetsImageProps) => {
  const { src, type, alt, ...rest } = props;
  if (type === "server") {
    return <ServerAsset {...props} />;
  }
  return <img src={`/assets/images/${src}`} alt={alt} {...rest} />;
};

export default Asset;
